<p-breadcrumb
  [model]="[
    { label: 'Produtos', routerLink: ['/products'] },
    {
      label: productId() ? 'Editar Produto' : 'Novo produto',
      routerLink: productId()
        ? ['/products/update/' + productId()]
        : ['/products/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'] }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(productId()){
        <h5 class="font-bold">Editar Produto</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Novo Produto</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-2 items-center">
        <div class="w-full flex gap-2 items-center">
          <label for="status"> Status: </label>
          <p-select
            formControlName="status"
            [options]="statusOptions"
            placeholder="Selecione o status"
            class="w-full"
            placeholder="Informe o nome"
          >
          </p-select>

          <app-form-error [control]="formGroup.get('status')" />
          <app-form-server-error [control]="formGroup.get('status')" />
        </div>

        <p-button
          label="Cancelar"
          routerLink="/products"
          severity="secondary"
          rounded
          class="btn-secondary-outline"
        >
        </p-button>
        <p-button type="submit" label="Salvar" rounded></p-button>
      </div>
    </div>
  </p-toolbar>

  <div class="w-full flex flex-wrap xl:flex-nowrap gap-5">
    <div class="w-full xl:w-1/2">
      <div class="card">
        <h5 class="font-bold">Informações gerais</h5>

        <div class="w-full mt-5 space-y-5">
          <div>
            <label for="name"> Nome *</label>
            <input
              pInputText
              type="text"
              formControlName="name"
              class="w-full"
              placeholder="Informe o nome"
            />
            <app-form-error [control]="formGroup.get('name')" />
            <app-form-server-error [control]="formGroup.get('name')" />
          </div>

          <div>
            <label for="sku"> SKU *</label>
            <input
              pInputText
              type="text"
              formControlName="sku"
              class="w-full"
              placeholder="Informe o SKU"
            />
            <app-form-error [control]="formGroup.get('sku')" />
            <app-form-server-error [control]="formGroup.get('sku')" />
          </div>

          <div>
            <label for="brandId"> Marca *</label>
            <p-select
              [options]="brandsDropdown()"
              [loading]="brandSelectLoading()"
              formControlName="brandId"
              optionLabel="label"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecione a marca"
              class="w-full"
              (onChange)="onBrandChange($event.value)"
            >
            </p-select>
            <app-form-error [control]="formGroup.get('brandId')" />
            <app-form-server-error [control]="formGroup.get('brandId')" />
          </div>

          <div>
            <label for="categoryId"> Categoria *</label>
            <p-select
              [options]="categoriesDropdown()"
              [loading]="categorySelectLoading()"
              formControlName="categoryId"
              optionLabel="label"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecione a categoria"
              class="w-full"
              (onChange)="onCategoryChange($event.value)"
            >
            </p-select>
            <app-form-error [control]="formGroup.get('categoryId')" />
            <app-form-server-error [control]="formGroup.get('categoryId')" />
          </div>

          <div>
            <label for="modelId"> Modelo *</label>
            <p-select
              [options]="modelsDropdown()"
              [loading]="modelSelectLoading()"
              formControlName="modelId"
              optionLabel="label"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecione o modelo"
              class="w-full"
              (onChange)="onModelChange($event.value)"
            >
            </p-select>
            <app-form-error [control]="formGroup.get('modelId')" />
            <app-form-server-error [control]="formGroup.get('modelId')" />
          </div>

          <div>
            <label for="modelVersionId"> Versão do modelo *</label>
            <p-select
              [options]="modelVersionsDropdown()"
              [loading]="modelVersionSelectLoading()"
              formControlName="modelVersionId"
              optionLabel="label"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Selecione a versão"
              class="w-full"
            >
            </p-select>
            <app-form-error [control]="formGroup.get('modelVersionId')" />
            <app-form-server-error
              [control]="formGroup.get('modelVersionId')"
            />
          </div>
        </div>
      </div>
      <div class="card">
        <h5 class="font-bold">Especificações Técnicas *</h5>

        <div class="w-full mt-5">
          <div class="w-full">
            <div class="flex items-center justify-end gap-2 mb-2">
              <p-button
                type="button"
                rounded
                class="btn-outline-secondary"
                severity="secondary"
                (click)="toggleHtmlMode()"
              >
                {{ htmlMode() ? "Visual" : "HTML" }}
              </p-button>
            </div>

            @if (!htmlMode()) {
            <quill-editor
              formControlName="description"
              class="description-editor"
              style="width: 100%"
              placeholder="Informe as especificações técnicas do produto"
              [modules]="quillModules"
              [formats]="quillFormats"
            ></quill-editor>
            } @else {
            <textarea
              #htmlArea
              class="form-control font-monospace w-full"
              rows="14"
              [value]="htmlText()"
              (input)="onHtmlInput($event)"
              placeholder="Edite o HTML aqui..."
            ></textarea>

            <small class="text-muted d-block mt-1">
              Dica: use <code>&lt;br&gt;</code> para quebra de linha dentro do
              mesmo parágrafo.
            </small>
            }
          </div>
          <app-form-error [control]="formGroup.get('description')" />
          <app-form-server-error [control]="formGroup.get('description')" />
        </div>
      </div>
    </div>

    <div class="w-full xl:w-1/2">
      <div class="card">
        <div class="flex flex-wrap items-center justify-between mb-3">
          <h5 class="font-bold">Atributos do produto</h5>
          <p-button
            type="button"
            label="Adicionar Atributo"
            (click)="addVariationAttribute()"
            rounded
          ></p-button>
        </div>

        <div formArrayName="attributes">
          @if(variationAttributesArray.controls.length === 0) {
          <p class="text-sm text-gray-500">Nenhum atributo adicionado.</p>
          } @for (group of variationAttributesArray.controls; let i = $index;
          track i) {
          <div [formGroupName]="i" class="mt-5">
            <div
              class="w-full flex flex-wrap items-center md:flex-nowrap gap-4"
            >
              <div class="w-full">
                <label>Atributo *</label>
                <p-select
                  [options]="variationAttributesDropdown()"
                  [loading]="variationAttributeSelectLoading()"
                  formControlName="variationAttributeId"
                  optionLabel="label"
                  [filter]="true"
                  filterBy="label"
                  [showClear]="true"
                  placeholder="Selecione o atributo"
                  class="w-full"
                  (onChange)="onVariationAttributeChange(i, $event.value)"
                >
                </p-select>
                <app-form-error
                  [control]="
                    getVariationAttributeControl(i, 'variationAttributeId')
                  "
                />
                <app-form-server-error
                  [control]="
                    getVariationAttributeControl(i, 'variationAttributeId')
                  "
                />
              </div>

              <div class="w-full">
                <label>Valor *</label>
                <p-select
                  [options]="variationAttributeValuesDropdown()[i] || []"
                  [loading]="variationAttributeValuesLoading()[i] || false"
                  formControlName="variationAttributeValueId"
                  optionLabel="label"
                  [filter]="true"
                  filterBy="label"
                  [showClear]="true"
                  placeholder="Selecione o valor"
                  class="w-full"
                >
                </p-select>
                <app-form-error
                  [control]="
                    getVariationAttributeControl(i, 'variationAttributeValueId')
                  "
                />
                <app-form-server-error
                  [control]="
                    getVariationAttributeControl(i, 'variationAttributeValueId')
                  "
                />
              </div>
              <div class="text-right lg:mt-3">
                <p-button
                  type="button"
                  icon="ph-duotone ph-trash text-2xl text-red-800"
                  (click)="removeVariationAttribute(i)"
                  link
                ></p-button>
              </div>
            </div>
          </div>
          }
        </div>

        <app-form-error [control]="formGroup.get('attributes')" />
        <app-form-server-error [control]="formGroup.get('attributes')" />
      </div>

      <div class="card">
        <h5 class="font-bold">Imagens do Produto *</h5>
        <p>
          Entre 4 a 8 imagens | Tamanho mínimo de 2048x2048px | .PNG com fundo
          transparente
        </p>
        <div class="w-full">
          <div class="mt-2 mb-4">
            <input
              pInputText
              type="file"
              class="w-full"
              accept="image/*"
              (change)="onFilesSelected($event)"
              multiple
            />
            <app-form-error [control]="formGroup.get('images')" />
            <app-form-server-error [control]="formGroup.get('images')" />
          </div>

          @if(productImages().length > 0) {
          <div
            cdkDropList
            class="grid gap-4 grid-cols-2 md:grid-cols-4"
            (cdkDropListDropped)="onImageDrop($event)"
          >
            @for (image of productImages(); track image; let i = $index) {
            <div
              class="relative border border-gray-300 rounded-md p-2 flex flex-col justify-between h-full bg-surface-50"
              cdkDrag
            >
              <img
                [src]="image.previewUrl"
                alt="productImage"
                class="w-full object-cover rounded-md"
              />

              @if(i === 0) {
              <span
                class="absolute top-2 left-2 bg-primary text-white text-xs px-2 py-1 rounded-full"
              >
                Imagem principal
              </span>
              }

              <div class="flex items-center justify-between w-full mt-1">
                <span class="text-xs text-gray-600">
                  Ordem: {{ image.sortOrder }}
                </span>
                <button
                  type="button"
                  pButton
                  icon="pi pi-trash"
                  class="p-button-text p-button-sm"
                  (click)="removeImage(i)"
                ></button>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>
<p-toast/>